'use strict';/* global define, console */define('modules/feedback/directives/documents-tab/controller',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     controller.$inject = ["$scope", "Documents", "Modals"];
function controller($scope,Documents,Modals){// jshint validthis:true
// jshint latedef:false
var ctrl=this;ctrl.uploadDocuments=uploadDocuments;ctrl.downloadAllDocuments=downloadAllDocuments;ctrl.documents=Documents.supervisor();// ---
/**
     * Upload documents
     */function uploadDocuments(){Modals.uploadDocument('supervisor',null,ctrl.documents);}/**
     * Download all documents
     *
     * @param  {Object} files - Documents informaiton collection
     */function downloadAllDocuments(files){Documents.downloadAll(files);}}module.exports=controller;});
